import * as ActionTypes from '../actions/actionTypes';

const defaultState = {
  currentOrganizationId: null,
};

const organizations = (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_MEMBER: {
      console.log('Reducer works');
      return state;
    }
    case '@@reactReduxFirebase/SET': {
      // @TODO probably that's not the best approach to set default organizationid
      if (state.currentOrganizationId === null) {
        if (action.path === '/organizations' && action.ordered && action.ordered.length > 0) {
          return { ...state, currentOrganizationId: action.ordered[0].key };
        }
      }
      return state;
    }
    default:
      return state;
  }
};

export default organizations;



// WEBPACK FOOTER //
// ./src/redux/reducers/organizations.js